// 各平台 佳安，佳安，TBR大胎
export enum AppPlatformEnums {
  TBR = "TBR"
}

export enum ThemeNameEnums {
  TBR = "platform-theme-1"
}

// 二批商
export const SECOND_MERCHANT_TYPE = "K2 AppM";

/**
 * 固定的参数
 */
export enum GTGroupFixedParam {
  cartType = "7"
}
/**
 * GTGroup 固定的参数
 */
export enum GTGroupFixedOrgParam {
  // orgCode = "GTGroup"
  orgCode = "default"
}

/**
 *  活动价 固定的参数
 */
export enum GTGroupActivityParam {
  cartType = "8"
}

/**
 *  TBR 固定的参数 ——大胎
 */
export enum GTGroupTBRFixedParam {
  cartType = "9",
  productOrgCode = "default",
  orgCode = "default"
}
